/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React, { FC } from 'react';
import { SelectProps } from 'antd';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { sortBy } from 'lodash';

import { useHandbook } from '~/controllers/handbook';
import direction from '~/utils/direction';
import { useDirection } from '~/hooks/i18nHooks';
import Select from './Select';
import { Hint } from '..';

const BusinessLineSelect: FC<SelectProps<string> & { businessNature: string | undefined; hint?: boolean }> = (
  props,
) => {
  const { businessNature, hint } = props;

  const { t } = useTranslation();

  const handbook = useHandbook();
  const options = handbook.data?.handbooks
    ?.find((item) => item.key === 'businessNature')
    ?.values?.find((item) => item.apiValue === businessNature)
    ?.values?.find((item) => item.key.includes('businessLine'))
    ?.values?.map((item) => ({ label: item.localizedValue, value: item.apiValue!, key: item.key }));

  // Sort options by label using sortBy from lodash
  const sortedOptions = sortBy(options, 'label');

  const dir = useDirection();

  return (
    <Container dir={dir}>
      <Select
        loading={handbook.isLoading}
        disabled={handbook.isLoading}
        showSearch
        options={sortedOptions}
        {...props}
      />
      {hint && (
        <Hint text={t('Please select the business line which most closely fits your primary trading purpose.')} />
      )}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
  .Hint {
    ${direction.margin.left(16)};
  }
`;

export default BusinessLineSelect;
